import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { NavLink } from 'react-router-dom';
import Right_arror from '../img/icon/right-arror.png';
import Right_arror_w from '../img/icon/Expand_right_light_w.png';
import { useGetAlltopicQuery } from '../services/aplms';
import Loader from '../loader/Loader';
import "./KeyTopic.css";

const KeyTopic = (props) => {
  const slug = props.propsdata;
  const topicdata = useGetAlltopicQuery(slug);

  if (topicdata.isLoading) return <Loader />;
  
  if (!topicdata.data || topicdata.data.length === 0)
    return (
      <div className="coming-soon glass-card">
        <h1>Coming Soon</h1>
      </div>
    );

  if (topicdata.isError)
    return <h1>An error occurred {topicdata.error.error}</h1>;

  // Sort the topic data by name with proper numerical sorting
  // This assumes the topic name starts with a number like "1.1", "1.2", etc.
  const sortedTopicData = [...topicdata.data].sort((a, b) => {
    try {
      // Extract the numerical part from the beginning of the name
      // This regex matches a number, optionally followed by a decimal point and another number
      const aMatch = String(a.name || '').match(/^(\d+)(?:\.(\d+))?/);
      const bMatch = String(b.name || '').match(/^(\d+)(?:\.(\d+))?/);
      
      // If there are no matches, return 0 (keep original order)
      if (!aMatch || !bMatch) return 0;
      
      // Get the major number (e.g., "1" from "1.2")
      const aMajor = parseInt(aMatch[1]) || 0;
      const bMajor = parseInt(bMatch[1]) || 0;
      
      // Compare major numbers
      if (aMajor !== bMajor) {
        return aMajor - bMajor;
      }
      
      // Get the minor number (e.g., "2" from "1.2"), default to 0 if not present
      const aMinor = parseInt(aMatch[2] || '0');
      const bMinor = parseInt(bMatch[2] || '0');
      
      // Compare minor numbers
      return aMinor - bMinor;
    } catch (error) {
      console.warn("Error sorting topics:", error);
      return 0; // Keep original order for problematic items
    }
  });

  return (
    <div className="topic-container">
      <Row>
        {sortedTopicData.map((topic) => (
          <Col sm={4} key={topic.id || topic.slug} className="topic-col">
            <NavLink 
              to={'/Unit/' + slug} 
              className="topic-card glass-card"
            >
              <div className="topic-content">
                <h4>{topic.name}</h4>
                <div className="topic-arrow">
                  <img 
                    src={Right_arror} 
                    className="arrow-icon" 
                    alt="arrow" 
                  />
                </div>
              </div>
              <div className="hover-indicator"></div>
            </NavLink>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default KeyTopic;